import React from "react";
import {FaAppStore, FaEnvelope, FaFacebook, FaGooglePlay, FaInstagram, FaPaw} from "react-icons/fa";
import "./Footer.css";

function Footer() {
	return (
		<footer className="site-footer">
			<div className="site-footer__inner">
				<div className="site-footer__top">
					<div className="site-footer__brand">
						<div className="site-footer__mark"><FaPaw/></div>
						<div>
							<strong>Barkr</strong>
							<p>Better walks start with better company.</p>
						</div>
					</div>

					<div className="site-footer__links">
						<div>
							<strong>Discover</strong>
							<a href="/#how-it-works">How it works</a>
							<a href="/#safety">Safety</a>
							<a href="/download">Download Barkr</a>
						</div>
						<div>
							<strong>Support</strong>
							<a href="/contact">Contact us</a>
							<a href="/child-safety">Child safety</a>
							<a href="mailto:support@barkr.app">Help center</a>
						</div>
						<div>
							<strong>Legal</strong>
							<a href="/privacy">Privacy</a>
							<a href="/terms">Terms</a>
							<a href="/eula">EULA</a>
						</div>
					</div>
				</div>

				<div className="site-footer__bottom">
					<a className="site-footer__email" href="mailto:support@barkr.app">
						<FaEnvelope/> support@barkr.app
					</a>
					<p>© {new Date().getFullYear()} Barkr Ltd. Made for happier walks.</p>
					<div className="site-footer__socials">
						<a href="https://facebook.com/barkrapp" aria-label="Barkr on Facebook"><FaFacebook/></a>
						<a href="https://www.instagram.com/barkrapp/" aria-label="Barkr on Instagram"><FaInstagram/></a>
						<a href="https://apps.apple.com/us/app/barkr-meet-dog-owners/id6444854210" aria-label="Barkr on the App Store"><FaAppStore/></a>
						<a href="https://play.google.com/store/apps/details?id=com.barkr.barkr" aria-label="Barkr on Google Play"><FaGooglePlay/></a>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
